<div class="input-container" (click)="focusInput()" (keyup)="focusInput()" (keydown)="focusInput()">
    <input #inputElement
        [id]="id"
        [type]="type"
        class="input-field"
        [value]="model !== undefined && model !== null ? model : ''"
        (input)="onInputChange($event)"
        placeholder=" "
    />
    <label [for]="id" class="input-label" #inputLabelElement>{{ placeholder }}</label>
</div>
<div class="input-error-message" *ngIf="errorMessage && setErrorState">{{errorMessage}}</div>
